import { render, staticRenderFns } from "./SAPCustomerMaterialMappingEdit.vue?vue&type=template&id=4a7caf18&scoped=true&"
import script from "./SAPCustomerMaterialMappingEdit.vue?vue&type=script&lang=js&"
export * from "./SAPCustomerMaterialMappingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7caf18",
  null
  
)

export default component.exports